/**
 * This type is a helper to pass boolean values as string to the DOM.
 * This is useful when we want to pass a boolean value to a custom styled element and suppress the warning:
 * Warning: Received `true` for a non-boolean attribute `attribute`.
 */
export type booleanish = 'true' | 'false';

/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const Booleanish = (value: any): booleanish => (value ? 'true' : 'false');
